import { motion } from "framer-motion";
import PageTransition from "@/components/PageTransition";
import GalleryGrid from "@/components/GalleryGrid";
import CTABlock from "@/components/CTABlock";

export default function Work() {
  return (
    <PageTransition>
      <section className="pt-40 md:pt-56 pb-8 relative overflow-hidden" data-testid="work-page">
        <div className="absolute inset-0 halftone-bg opacity-30 halftone-fade pointer-events-none" aria-hidden />
        <div className="relative max-w-[1440px] mx-auto px-5 md:px-10">
          <div className="font-mono text-[11px] tracking-[0.32em] uppercase text-[color:var(--text-2)]">— Selected Work</div>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="font-display mt-6 text-[15vw] md:text-[128px] leading-[0.92] tracking-[-0.03em]"
          >
            The <em className="italic text-[color:var(--accent)]">portfolio.</em>
          </motion.h1>
          <p className="mt-8 max-w-[680px] text-[color:var(--text-2)] text-[17px] leading-[1.65]">
            Real print jobs, real materials — a small selection from three decades of finished work.
          </p>
        </div>
      </section>
      <GalleryGrid />
      <CTABlock />
    </PageTransition>
  );
}
